import { TermRoute } from './term.route';
import { MainPageLayoutComponent } from 'app/component/main-page-layout/main-page-layout.component';
import { SiteManagmentRoute } from 'src/domains/site-managment/site-managment.route';
import { RouteSubComponent } from 'authorization';
import { Routes } from '@angular/router';

export const termRouting: Routes = [
  {
    path: 'dashboard',
    loadComponent: () =>
      import(
        'src/domains/theme/app/component/full-layout/full-layout.component'
      ).then((c) => c.FullLayoutComponent),
    data: {
      breadcrumb: {
        skip: true,
      },
    },
    children: [
      {
        path: '',
        redirectTo: 'create_term',
        pathMatch: 'full',
      },
      {
        path: 'create_term',
        loadComponent: () =>
          import('./app/component/create-term/create-term.component').then(
            (c) => c.CreateTermComponent,
          ),
        data: {
          breadcrumb: {
            label: 'اضافه کردن قوانین ومقررات',
            parent: ['قوانین و مقررات'],
            parentUrl: [SiteManagmentRoute.map.term.dashboard.terms_list],
          },
          title: '',
        },
      } as RouteSubComponent<typeof TermRoute.map.dashboard, 'create_term'>,
      {
        path: 'edit_term',
        loadComponent: () =>
          import('./app/component/edit-term/edit-term.component').then(
            (c) => c.EditTermComponent,
          ),
        data: {
          breadcrumb: {
            label: 'ویرایش قوانین ومقررات',
            parent: ['قوانین و مقررات'],
            parentUrl: [SiteManagmentRoute.map.term.dashboard.terms_list],
          },
          title: '',
        },
      } as RouteSubComponent<typeof TermRoute.map.dashboard, 'edit_term'>,
      {
        path: 'terms_list',
        loadComponent: () =>
          import('./app/component/list-term/list-term.component').then(
            (c) => c.ListTermComponent,
          ),
        data: {
          breadcrumb: {
            skip: true,
          },
          title: '',
        },
      } as RouteSubComponent<typeof TermRoute.map.dashboard, 'terms_list'>,
    ],
  },
  {
    path: 'mainpage',
    component: MainPageLayoutComponent,
    children: [
      {
        path: 'terms_and_conditions',
        loadComponent: () =>
          import('./app/component/app-view-term/app-view-term.component').then(
            (c) => c.AppViewTermComponent,
          ),
      } as RouteSubComponent<
        typeof TermRoute.map.mainpage,
        'terms_and_conditions'
      >,
    ],
  },
];
